import { Flex } from "theme-ui";
import Button from "../Buttons/Button";
import { ButtonProps, TextProps } from "../../../custom";

interface Props {
  heading: TextProps;
  subText?: TextProps;
  button1?: ButtonProps;
  videoLink: string;
  quote?: TextProps;
  author?: TextProps;
  disclaimer?: TextProps;
  backgroundColor?: string;
  showVideo?: boolean;
}

const VideoSection = ({
  heading,
  subText,
  button1,
  quote,
  author,
  disclaimer,
  showVideo,
  videoLink,
  backgroundColor,
}: Props) => {
  return (
    <Flex
      sx={{
        background: showVideo ? backgroundColor : "white",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mt: [showVideo ? -100 : 0, null, null, showVideo ? -350 : -300],
        position: "relative",
        textAlign: "center",
        px: [3, null, null, 6],
        pb: [showVideo ? 6 : 3, null, null, showVideo ? 100 : 0],
      }}
    >
      {showVideo && (
        <iframe
          data-sal={"slide-up"}
          data-sal-easing="easeOutQuart"
          data-sal-duration={1000}
          data-sal-delay={"100"}
          src={videoLink}
          sx={{
            width: ["90%", null, null, "70%"],
            height: [300, 400, null, 550],
            mt: [0, 0],
          }}
        />
      )}
      <div
        sx={{
          px: ["0px", 5],
          py: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        data-sal={"slide-up"}
        data-sal-easing="easeOutQuart"
        data-sal-duration={1000}
        data-sal-delay={"100"}
      >
        <h2
          sx={{
            color: heading.color,
            m: 1,
          }}
        >
          {heading.text}
        </h2>
        {subText && (
          <p
            sx={{
              color: subText.color,
              lineHeight: "45px",
              pb: 3,
              maxWidth: 1200,
            }}
          >
            {subText.text}
          </p>
        )}
        {quote && (
          <h2
            sx={{
              color: quote.color,
              maxWidth: 800,
              m: 0,
              fontStyle: "italic",
            }}
          >
            {quote.text}
          </h2>
        )}
        {author && (
          <h2 sx={{ color: author.color, m: 0, pt: 3, fontWeight: 500 }}>
            {author.text}
          </h2>
        )}
        {button1 && <Button {...button1} />}
        {/* {disclaimer && (
          <p
            sx={{
              variant: "text.disclaimer",
              pt: 5,
              color: disclaimer.color,
            }}
          >
            {disclaimer.text}
          </p>
        )} */}
      </div>
    </Flex>
  );
};

export default VideoSection;
